import React, { useState, useEffect, useContext, useCallback, useRef, useMemo } from 'react';
import { useFetch, Context, useSave } from 'store';

import { Button, Icon, Card, DatePicker, notification, Checkbox } from 'antd';
import { Button as CustomButton } from '_src/ui';

import { AsyncTable, Fields } from '_src/components';
import { PersistentRepo } from '_src/shared/repo';
import { Restricted } from '_src/shared/restrict';
import { objToSnakeCase, debounce } from '_src/utils';
import services from '_src/services';
import { Select, Input, RangePicker } from '_src/shared/form-helpers';

import { camelToSnakeCase } from '../../utils/helpers';
import { extendSchemaWithDefects } from './helpers';

import { PageContainer } from '_src/shared/styles';

import { Form } from 'form';

import qs from 'qs';
import moment from 'moment';

import { BrowserMultiFormatReader } from '@zxing/library';

import {
  PageTitle,
  Search,
  ButtonContainer,
  FormContainer,
  Warning,
  FieldsContainer,
  DefectsFieldsContainer,
  HighlightedFieldsContainer,
  StyledSelect,
  HighlightedWarning
} from './styles';
import BaseModal from './baseModal';

export default () => {
  const REPORT_TYPES = {
    DVIR: 'dvir',
    NON_INSPECTION: 'non_inspection',
    NOT_CLOSED: 'not_closed'
  };
  const baseApi = GLOBALS.BASE_API;
  const buttonColor = GLOBALS.colors;
  const resource = 'dvir';
  const now = moment();

  const videoRef = useRef(null);
  const codeReaderRef = useRef(null);

  const [error, setError] = useState(null);

  const token = PersistentRepo.get('token');

  const config = services[resource];
  const locationsConfig = services['studentRecords'];

  const { setShown, getShown, getData, refreshResource } = useContext(Context);
  const user = getData('user');

  const getInitialLocation = () => {
    const allBranchesSelected = PersistentRepo.get('allBranches');

    const location = allBranchesSelected ? allBranchesSelected : PersistentRepo.get('location');

    const branchId = user.branchId || 1;

    return location ? location : `allxallx${branchId}`;
  };

  const getInitialId = type => {
    const [locationType, locationId, branchId] = getInitialLocation().split('x');
    return type === 'locationType' ? locationType : branchId;
  };

  const [reportType, setReportType] = useState(
    () => localStorage.getItem('reportType') || REPORT_TYPES.DVIR
  );
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [skip, setSkip] = useState(0);
  const [defectsList, setDefectsList] = useState([]);
  const [allTemplates, setAllTemplates] = useState([]);

  const [location, setLocation] = useState('all');
  const [formYardId, setFormYardId] = useState('');
  const [assetBarcode, setAssetBarcode] = useState('');
  const [salesforceAssetId, setAssetIdentificationNumber] = useState('');
  const [marketManager, setMarketManager] = useState('');
  const [driverName, setDriverName] = useState('');
  const [defectiveItems, setDefectiveItems] = useState('all');
  const [assetCondition, setAssetCondition] = useState('all');
  const [assetStatus, setAssetStatus] = useState('all');
  const [assetName, setAssetName] = useState('');
  // const [date, setDate] = useState('');
  const [dateRanges, setDateRanges] = useState({
    startDate: null,
    endDate: null
  });

  const { startDate, endDate } = dateRanges;

  const [vehicleInfo, setVehicleInfo] = useState({});
  const [templateId, setTemplateId] = useState(null);

  const [assetBarcodeNr, setAssetBarcodeNr] = useState(null);
  const [dynamicSchema, setDynamicSchema] = useState(config.schema);
  const [assetLocation, setAssetLocation] = useState(null);
  const [atLeastOneDefect, setAtLeastOneDefect] = useState();
  const [noDefects, setNoDefects] = useState(false);
  const [refreshDefects, setRefreshDefects] = useState(false);

  const formApi = useRef(null);

  const { get: getLocations, busy } = useFetch({ ...locationsConfig.getLocations });
  const { get: getVehicle } = useFetch(config.getVehicle);
  const { get: getTemplates } = useFetch(config.getTemplate);
  const { save: createInspection } = useSave(config.createInspection);
  const { save: updateVehicle } = useSave(config.updateVehicle);
  const { save: requestVehicleCreation } = useSave(config.requestCreation);

  useEffect(() => {
    getLocations().then(data => {
      setLocations(data.filter(item => item.type === 0));
      setLoading(false);
    });
    getTemplates().then(res => {
      const allTemplatesFlat = res[0].data.template.templates.flatMap(template =>
        template.sections.flatMap(section =>
          section.items.map((item, index) => ({
            templateId: template.id,
            id: item.id,
            label: item.itemName,
            vehicleType: template.vehicleType,
            name: `defect_${item.id}`,
            component: 'checkbox',
            ...(index === 0 ? { title: section.name } : {})
          }))
        )
      );

      setAllTemplates(allTemplatesFlat);
    });
  }, []);
  const tableData = getData('userActivityLogs');
  const totalCount = tableData?.total;

  const [filterParams, setFilterParams] = useState({
    limit: 20,
    skip
    // location: getInitialId('branchId')
  });

  const debounceCallback = useCallback(
    debounce(
      params => {
        setFilterParams(params);
      },
      1000,
      false
    ),
    []
  );

  const handleTableSort = (_, __, sort) => {
    if (!sort.columnKey) {
      return;
    }

    setFilterParams(prev => ({
      ...prev,
      sortBy: camelToSnakeCase(sort.columnKey),
      sortOrder: sort.order === 'ascend' ? 'asc' : 'desc'
    }));
  };

  const playBeep = () => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();

    oscillator.type = 'square';
    oscillator.frequency.value = 600; // Hz
    gain.gain.value = 0.1; // volume

    oscillator.connect(gain);
    gain.connect(ctx.destination);

    oscillator.start();
    oscillator.stop(ctx.currentTime + 0.15); // short beep ~150ms
  };

  const startScanner = async () => {
    // setError(null);
    // setResult(null);
    // setIsScanning(true);

    const codeReader = new BrowserMultiFormatReader();
    codeReaderRef.current = codeReader;

    try {
      await codeReader.decodeFromVideoDevice(
        null, // automatically select camera
        videoRef.current,
        (res, err) => {
          if (res && res.getRawBytes()) {
            playBeep();
            setAssetBarcodeNr(res.getText());
            getVehicleByBarcode(res.getText());

            stopScanner();
          }
          if (err && !(err.name === 'NotFoundException')) {
            console.log('err', err);
            setError(err.message || String(err));
          }
        }
      );
    } catch (e) {
      setError(e.message || String(e));
    }
  };

  const stopScanner = () => {
    codeReaderRef.current?.reset();
  };

  const closeModal = () => {
    setShown('scan', false);
    setShown('enterBarcode', false);
    setShown('noAssetFound', false);
    setShown('locationMatch', false);
    setShown('dvirForm', false);
    setShown('finalStep', false);
    setShown('vehicleNotAvailable', false);

    setAssetBarcodeNr('');
    // setNoDefects(false);
    // setAtLeastOneDefect(false);

    formApi?.current?.resetFields();
    stopScanner();
  };

  const getVehicleByBarcode = barcode => {
    if (!barcode) return;

    setLoading(true);

    getVehicle({ replace: { barcode } }).then(async response => {
      setShown('scan', false);
      setShown('enterBarcode', false);

      // --- Not found ---
      if (response.code === 404) {
        setShown('noAssetFound', true);
        return setLoading(false);
      }

      if (response.success === 0) {
        notification.error({
          message: 'Failed to retrieve vehicle data!',
          duration: 5
        });
        return setLoading(false);
      }

      // --- Found vehicle ---
      const vehicle = response.data.vehicle;
      setVehicleInfo(vehicle);

      const yardId = vehicle.yardId;
      const asset = locations.find(item => item.id.split('x')[2] == yardId);
      if (asset) {
        setAssetLocation(asset.id);
      }

      // --- Vehicle not available ---
      if (!vehicle.isAvailable) {
        setShown('vehicleNotAvailable', true);
        return setLoading(false);
      }

      setShown('locationMatch', true);

      const currentTemplate = allTemplates.filter(item => item.vehicleType === vehicle.vehicleType);

      setTemplateId(currentTemplate?.[0]?.templateId ?? null);
      setDefectsList(currentTemplate);
      setDynamicSchema(extendSchemaWithDefects(config.schema, currentTemplate));

      setLoading(false);
    });
  };

  const continueUpdate = () => {
    const [locationType, locationId, branchId] = assetLocation.split('x');
    setLoading(true);
    if (assetLocation.includes(vehicleInfo.yardId)) {
      setShown('locationMatch', false);
      setShown('dvirForm', true);
      setFormYardId(assetLocation);

      return setLoading(false);
    }

    // If asset location changed -> update location
    const asset = locations.find(item => item.id.split('x')[2] == branchId);

    updateVehicle({
      id: vehicleInfo.id,
      yardId: branchId
    }).then(res => {
      setLoading(false);

      const { vehicle } = res.data;

      setVehicleInfo({
        ...vehicleInfo,
        yardId: res.data.vehicle.yardId,
        yardName: res.data.vehicle.yardName
      });

      if (res.code === 200) {
        const assetLocation = locations.find(item => item.id.split('x')[2] == vehicle.yardId);
        if (assetLocation) setFormYardId(assetLocation.id);
        setShown('locationMatch', false);
        setShown('dvirForm', true);
      }
    });
  };

  const matchesLocation = useMemo(() => {
    if (!assetLocation) return true;
    const [, , branchId] = assetLocation.split('x');
    return +branchId === user.branchId;
  }, [assetLocation, user.branchId]);

  const submitForm = () => {
    setLoading(true);

    if (!formApi.current.validate()) {
      setLoading(false);
      return;
    }

    const values = formApi.current.values();
    const entries = Object.entries(values);

    const inspectionResponses = entries
      .filter(([key]) => key.startsWith('defect'))
      .map(([key, value]) => ({
        formItemId: Number(key.split('_')[1]),
        isDefective: value
      }));

    // if (!values.noDefects && inspectionResponses.filter(item => item.isDefective).length === 0) {
    //   setAtLeastOneDefect(true);
    //   setLoading(false);
    //   return;
    // }

    const otherFields = Object.fromEntries(
      entries.filter(
        ([key]) =>
          !key.startsWith('defect') &&
          key !== 'ownershipType' &&
          key !== 'yardName' &&
          key !== 'noDefects' &&
          key != 'inspectionType'
      )
    );

    const payload = {
      ...otherFields,
      inspectionResponses,
      vehicleId: vehicleInfo.id,
      formTemplateId: templateId
    };

    createInspection(payload).then(res => {
      setLoading(false);

      if (res.code === 200) {
        refreshResource('dvir');
        setShown('dvirForm', false);
        setShown('finalStep', true);
      }
    });
  };

  const downloadReport = async () => {
    setDownloadLoading(true);

    const query = qs.stringify(objToSnakeCase({ ...filterParams, skip }), {
      arrayFormat: 'comma'
    });

    try {
      const res = await fetch(`${baseApi}/dvir/download_dvir_reports?${query}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Download failed');
      const blobUrl = URL.createObjectURL(await res.blob());
      const link = Object.assign(document.createElement('a'), {
        href: blobUrl,
        download: 'dvir_report.csv'
      });

      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('Download error:', err);
    } finally {
      setDownloadLoading(false);
    }
  };

  const downloadInspectionPdf = async inspectionId => {
    const response = await fetch(`${baseApi}/dvir/download_pdf?inspection_id=${inspectionId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    // if (response.code != 200) {
    //   alert('Failed to fetch PDF');
    //   return;
    // }

    window.open(url, '_blank');
  };

  const downloadNonInspectionReport = async () => {
    setDownloadLoading(true);

    const query = qs.stringify(objToSnakeCase({ ...filterParams, skip }), {
      arrayFormat: 'comma'
    });

    try {
      const res = await fetch(`${baseApi}/dvir/download_no_inspection_report?${query}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Download failed');
      const blobUrl = URL.createObjectURL(await res.blob());
      const link = Object.assign(document.createElement('a'), {
        href: blobUrl,
        download: 'non_inspection_vehicles_report.csv'
      });

      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error('Download error:', err);
    } finally {
      setDownloadLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (getShown('dvirForm') && formApi.current) {
        formApi.current.setField('ownershipType', vehicleInfo.ownershipType);
        formApi.current.setField('yardId', vehicleInfo.yardId);
        formApi.current.setField('yardName', vehicleInfo.yardName);
        formApi.current.setField('inspectionDate', now);
        formApi.current.setField('inspectionType', vehicleInfo.inspectionType);
      }
    }, 1000);
  }, [getShown('dvirForm')]);

  useEffect(() => {
    setTimeout(() => {
      if (getShown('noAssetFound') && formApi.current) {
        formApi.current.setField('barcode', assetBarcodeNr);
      }
    }, 1000);
  }, [getShown('noAssetFound')]);

  const switchReportType = (nextType, code) => {
    setSkip(0);
    setFilterParams(prev => {
      const { sortBy, sortOrder, ...rest } = prev;

      if (nextType === REPORT_TYPES.NON_INSPECTION && code) {
        return {
          ...rest,
          assetBarcode: code,
          skip: 0
        };
      }

      if (nextType === REPORT_TYPES.NOT_CLOSED && code) {
        return {
          ...rest,
          salesforceAssetId: code,
          skip: 0
        };
      }

      return { ...rest, skip: 0 };
    });

    setReportType(nextType);
  };

  const handleCreateAssetRequest = () => {
    setLoading(true);

    if (!formApi.current.validate()) {
      setLoading(false);
      return;
    }

    const payload = {
      ...formApi.current.values(),
      barcode: assetBarcodeNr
    };
    requestVehicleCreation(payload).then(res => {
      setLoading(false);

      if (res.code === 200) {
        notification.success({
          message:
            'Asset creation request submitted successfully. Our team will review and process it shortly.',
          duration: 5
        });
        setAssetBarcodeNr('');
        closeModal();
      }

      if (
        res.data.message ===
        `Error: Insert failed. First exception on row 0; first error: FIELD_CUSTOM_VALIDATION_EXCEPTION, An Asset with the name "Asset Request – ${assetBarcodeNr}" already exists. Please choose a unique name.: []`
      ) {
        notification.error({
          message: `Asset with barcode ${assetBarcodeNr} already exists. Please choose a unique barcode.`,
          duration: 5
        });
        setAssetBarcodeNr('');
        closeModal();
      }
    });
  };

  useEffect(() => {
    localStorage.setItem('reportType', reportType);

    closeModal();

    setMarketManager('');
    setDriverName('');
    setDefectiveItems('all');
    setAssetCondition('all');
    setAssetName('');
    setAssetStatus('all');
  }, [reportType, assetBarcode]);

  config.table.find(({ dataIndex }) => dataIndex === 'assetBarcode').onCell = inspection => ({
    onClick: () => {
      setAssetBarcode(inspection.assetBarcode);
      switchReportType(REPORT_TYPES.NON_INSPECTION, inspection.assetBarcode);
    }
  });

  config.table.find(({ dataIndex }) => dataIndex === 'salesforceAssetId').onCell = inspection => ({
    onClick: () => {
      setAssetIdentificationNumber(inspection.salesforceAssetId);
      switchReportType(REPORT_TYPES.NOT_CLOSED, inspection.salesforceAssetId);
    }
  });

  return (
    <PageContainer>
      <Card
        title={
          <StyledSelect
            value={reportType}
            onChange={value => switchReportType(value)}
            options={[
              {
                id: REPORT_TYPES.DVIR,
                label: "Driver's Vehicle Inspection Report"
              },
              {
                id: REPORT_TYPES.NON_INSPECTION,
                label: 'Missing Inspection Vehicles Report'
              },
              {
                id: REPORT_TYPES.NOT_CLOSED,
                label: 'Not Closed DVIRs Report'
              }
            ]}
          />
        }
      >
        {/* DVIR content */}
        {reportType === REPORT_TYPES.DVIR && (
          <>
            <Search>
              <Input
                label="Search by Asset Barcode #"
                onChange={e => {
                  if (e.length === 0) {
                    setAssetBarcode('');
                    const { assetBarcode, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  setAssetBarcode(e);
                  debounceCallback({ ...filterParams, assetBarcode: e });
                }}
                value={assetBarcode}
                allowClear
              />

              <Input
                label="Search by Asset Identification #"
                onChange={e => {
                  if (e.length === 0) {
                    setAssetIdentificationNumber('');
                    const { salesforceAssetId, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  setAssetIdentificationNumber(e);
                  debounceCallback({ ...filterParams, salesforceAssetId: e });
                }}
                value={salesforceAssetId}
                allowClear
              />

              <Input
                label="Search by Market Manager"
                onChange={e => {
                  if (e.length === 0) {
                    setMarketManager('');
                    const { marketManagerName, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  const [first, last = ''] = e.split(' ');
                  setMarketManager(e);
                  debounceCallback({
                    ...filterParams,
                    marketManagerName: `${first} ${last}`.trim()
                  });
                }}
                value={marketManager}
                allowClear
              />

              <Input
                label="Search by Driver"
                onChange={e => {
                  if (e.length === 0) {
                    setDriverName('');
                    const { driverName, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  const [first, last = ''] = e.split(' ');
                  setDriverName(e);
                  debounceCallback({ ...filterParams, driverName: `${first} ${last}`.trim() });
                }}
                value={driverName}
                allowClear
              />

              <Select
                label="Location"
                showSearch
                onChange={locationSelected => {
                  setLocation(locationSelected);
                  setMarketManager('');

                  const { studentName, instructor, ...restParams } = filterParams;
                  if (locationSelected === 'all') {
                    setFilterParams({ limit: filterParams.limit, skip: filterParams.skip });
                    PersistentRepo.set('allBranches', locationSelected);
                  } else {
                    const [locationType, locationId, branchId] = locationSelected.split('x');
                    setFilterParams(() => {
                      return {
                        ...restParams,
                        location: locationSelected ? branchId : getInitialId('branchId')
                      };
                    });
                  }
                }}
                options={[{ id: `all`, label: `All Branches` }, ...locations]}
                value={location}
              />

              <Select
                label="Defective Items"
                onChange={val => {
                  const selected = allTemplates.find(opt => opt.id === val);
                  const label = selected?.label;

                  setDefectiveItems(val);

                  if (val === 'all') {
                    const { defectiveItems, ...rest } = filterParams;
                    debounceCallback(rest);
                    return;
                  }

                  debounceCallback({
                    ...filterParams,
                    defectiveItems: label
                  });
                }}
                options={[
                  { id: 'all', label: 'All' },
                  ...new Map(allTemplates.map(item => [item.label, item])).values()
                ]}
                value={defectiveItems}
                showSearch
                // mode="multiple"
              />

              <Select
                label="Asset Condition"
                onChange={val => {
                  setAssetCondition(val);
                  if (val === 'all') {
                    const { assetCondition, ...rest } = filterParams;
                    debounceCallback(rest);

                    return;
                  }

                  debounceCallback({ ...filterParams, assetCondition: val });
                }}
                options={[
                  { id: 'all', label: 'All' },
                  { id: 'satisfactory', label: 'Satisfactory' },
                  { id: 'not_satisfactory', label: 'Not Satisfactory' }
                ]}
                value={assetCondition}
              />

              <RangePicker
                label="Date"
                allowClear={true}
                ranges={{
                  Today: [now, now],
                  'Last Week': [moment().subtract(7, 'd'), moment()],
                  'Last Month': [moment().subtract(1, 'months'), moment()]
                }}
                defaultValue={[startDate, endDate]}
                onChange={dates => {
                  const [startDate, endDate] = dates || [];

                  setDateRanges({
                    startDate: startDate || null,
                    endDate: endDate || null
                  });

                  debounceCallback({
                    ...filterParams,
                    dateFrom: startDate?.format('YYYY-MM-DD'),
                    dateTo: endDate?.format('YYYY-MM-DD')
                  });
                }}
              />
            </Search>

            <ButtonContainer>
              {/* <Restricted resource={'download_clockin_reports'} method="GET"> */}
              <Button type="default" onClick={() => downloadReport()} loading={downloadLoading}>
                <Icon type="download" /> Download report
              </Button>
              {/* </Restricted> */}
              <CustomButton
                filled={true}
                color={buttonColor.ORANGE}
                text="Manual entry"
                height={32}
                width={170}
                onClick={() => {
                  setShown('enterBarcode', true);
                }}
                alignSelf="flex-end"
              />
              <CustomButton
                filled={true}
                color={buttonColor.ORANGE}
                text="Barcode scan"
                height={32}
                width={170}
                onClick={() => {
                  setShown('scan', true);
                  setTimeout(() => startScanner(), 100);
                }}
                alignSelf="flex-end"
              />
            </ButtonContainer>

            <div style={{ overflowX: 'auto' }}>
              <AsyncTable
                resource={resource}
                pagination
                config={{
                  ...config,
                  table: [
                    ...config.table,
                    {
                      title: 'PDF Download',
                      key: 'download',
                      render: (_, { id }) => {
                        return (
                          <Button
                            onClick={() => downloadInspectionPdf(id)}
                            type="primary"
                            size="large"
                            style={{
                              backgroundColor: buttonColor.ORANGE,
                              borderColor: buttonColor.ORANGE
                            }}
                          >
                            PDF
                          </Button>
                        );
                      }
                    }
                  ]
                }}
                onChange={handleTableSort}
                params={filterParams}
                fileName={resource}
                onChangePage={setSkip}
              />
            </div>

            {/* Scan Modal */}
            {getShown('scan') && (
              <BaseModal
                visible={getShown('scan')}
                title="DVIR Scan"
                onCancel={closeModal}
                footerButtons={[
                  <Button key="cancel" onClick={closeModal}>
                    Close
                  </Button>
                ]}
              >
                <video ref={videoRef} style={{ width: '100%', height: 400 }} autoPlay />
              </BaseModal>
            )}

            {/* Enter Barcode Modal */}
            {getShown('enterBarcode') && (
              <BaseModal
                visible={getShown('enterBarcode')}
                title="DVIR Scan"
                onCancel={closeModal}
                footerButtons={[
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => getVehicleByBarcode(assetBarcodeNr)}
                    loading={loading}
                  >
                    Submit
                  </Button>,
                  <Button key="cancel" onClick={closeModal}>
                    Close
                  </Button>
                ]}
              >
                <Input
                  label="Enter the Asset Barcode"
                  onChange={e => setAssetBarcodeNr(e.trim())}
                  value={assetBarcodeNr}
                  allowClear
                />
              </BaseModal>
            )}

            {/* No Asset Found Modal */}
            {getShown('noAssetFound') && (
              <BaseModal
                visible={getShown('noAssetFound')}
                title="Request asset creation"
                footerButtons={[
                  <Button
                    key="submit"
                    type="primary"
                    onClick={handleCreateAssetRequest}
                    loading={loading}
                  >
                    Submit
                  </Button>,
                  <Button key="cancel" onClick={closeModal}>
                    Go Back
                  </Button>
                ]}
              >
                <div style={{ padding: '20px 0' }}>
                  <p style={{ marginBottom: 20 }}>
                    Asset with barcode:
                    <strong style={{ marginLeft: 5 }}>{assetBarcodeNr}</strong> was not found.
                    Please complete the vehicle details below to submit a registration request.
                  </p>

                  <Form
                    formApi={form => (formApi.current = form)}
                    schema={config.assetCreationSchema}
                    initialValues={{}}
                  >
                    <FieldsContainer columns={2}>
                      <Fields fields={config.assetCreationFields} />
                    </FieldsContainer>
                  </Form>
                </div>
              </BaseModal>
            )}

            {/* Vehicle not available Modal */}
            {getShown('vehicleNotAvailable') && (
              <BaseModal
                visible={getShown('vehicleNotAvailable')}
                title="DVIR Scan"
                footerButtons={[
                  <Button key="cancel" onClick={closeModal}>
                    Go Back
                  </Button>
                ]}
              >
                <p style={{ textAlign: 'center', padding: '80px 0' }}>
                  This asset is blocked due to a Not Satisfactory DVIR. New DVIRs cannot be created
                  until the issue is resolved.
                </p>
              </BaseModal>
            )}

            {/* Location Match Modal */}
            {getShown('locationMatch') && (
              <BaseModal
                visible={getShown('locationMatch')}
                title="DVIR Scan"
                onCancel={closeModal}
                footerButtons={[
                  <Button key="submit" type="primary" onClick={continueUpdate} loading={loading}>
                    Continue
                  </Button>,
                  <Button key="cancel" onClick={closeModal}>
                    Close
                  </Button>
                ]}
              >
                <FormContainer>
                  <Select
                    label="Last Seen Location"
                    showSearch
                    onChange={locationSelected => {
                      setAssetLocation(locationSelected);
                    }}
                    options={locations}
                    value={assetLocation}
                  />
                </FormContainer>
                {!matchesLocation && (
                  <Warning>
                    The asset's location does not match your current location. Do you want to
                    continue without updating the asset's location?
                  </Warning>
                )}
              </BaseModal>
            )}

            {/* DVIR Form Modal */}
            {getShown('dvirForm') && (
              <BaseModal
                visible={getShown('dvirForm')}
                title="DVIR Scan"
                onCancel={closeModal}
                footerButtons={[
                  <Button key="submit" type="primary" onClick={submitForm} loading={loading}>
                    Submit
                  </Button>,
                  <Button key="cancel" onClick={closeModal}>
                    Close
                  </Button>
                ]}
              >
                <span title="Driver’s Vehicle Inspection Report">
                  {vehicleInfo.inspectionType === 'Ending' && (
                    <HighlightedWarning>
                      <Icon
                        type="exclamation-circle-o"
                        style={{ color: '#FFB020', fontSize: 16, marginRight: '10px' }}
                      />
                      There is an existing open DVIR. Submitting this form will close the previous
                      inspection.
                    </HighlightedWarning>
                  )}
                  <Form
                    formApi={form => (formApi.current = form)}
                    schema={dynamicSchema}
                    initialValues={{}}
                  >
                    <FieldsContainer columns={2}>
                      <Fields fields={config.fields.details} />
                    </FieldsContainer>
                    {/* <Select
                    label="Location"
                    showSearch
                    onChange={locationSelected => {
                      setFormYardId(locationSelected);
                      formApi.current.setField('yardId', locationSelected);
                    }}
                    options={locations}
                    value={formYardId}
                    disabled
                  /> 
                  <Fields fields={config.fields.details.slice(2)} />*/}

                    {/* <HighlightedFieldsContainer>
                      <Checkbox
                        onChange={e => {
                          const checked = e.target.checked;
                          setNoDefects(checked);
                          setAtLeastOneDefect(!checked);
                          formApi.current.setField('noDefects', checked);
                          formApi.current.setField(
                            'conditionStatus',
                            checked ? 'satisfactory' : ''
                          );

                          defectsList.forEach(item => {
                            formApi.current.setField(
                              `defect_${item.id}`,
                              checked ? false : formApi.current.getField(`defect_${item.id}`)
                            );
                          });

                          setRefreshDefects(prev => !prev);
                        }}
                      >
                        No defects noted
                      </Checkbox>
                    </HighlightedFieldsContainer> */}
                    {atLeastOneDefect && (
                      <span
                        style={{
                          marginBottom: '5px',
                          marginRight: '0',
                          minWidth: 0,
                          color: '#f5222d'
                        }}
                      >
                        You must select at least one defect!
                      </span>
                    )}
                    <DefectsFieldsContainer>
                      <Fields
                        key={refreshDefects}
                        fields={defectsList.map(item => ({
                          ...item,
                          style: noDefects ? { opacity: 0.5, pointerEvents: 'none' } : {}
                        }))}
                      />
                    </DefectsFieldsContainer>
                    <FieldsContainer>
                      <Fields
                        fields={config.fields.driver.map(field => {
                          if (field.name !== 'conditionStatus') return field;

                          return {
                            ...field,
                            options: field.options.map(opt => ({
                              ...opt,
                              disabled: opt.id === 'not_satisfactory' && noDefects
                            }))
                          };
                        })}
                      />
                    </FieldsContainer>
                  </Form>
                </span>
              </BaseModal>
            )}

            {/* Form submitted successfully Modal */}
            {getShown('finalStep') && (
              <BaseModal
                visible={getShown('finalStep')}
                title="DVIR Scan"
                footerButtons={[
                  <Button key="cancel" onClick={closeModal}>
                    Go Back
                  </Button>
                ]}
              >
                <p style={{ textAlign: 'center', padding: '80px 0' }}>
                  Form submitted successfully.
                </p>
              </BaseModal>
            )}
          </>
        )}

        {/* NON_INSPECTION */}
        {reportType === REPORT_TYPES.NON_INSPECTION && (
          <>
            <Search>
              <Input
                label="Search by Asset Barcode #"
                onChange={e => {
                  if (e.length === 0) {
                    setAssetBarcode('');
                    const { assetBarcode, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  setAssetBarcode(e);
                  debounceCallback({ ...filterParams, assetBarcode: e });
                }}
                value={assetBarcode}
                allowClear
              />

              <Input
                label="Search by Asset Identification #"
                onChange={e => {
                  if (e.length === 0) {
                    setAssetIdentificationNumber('');
                    const { salesforceAssetId, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  setAssetIdentificationNumber(e);
                  debounceCallback({ ...filterParams, salesforceAssetId: e });
                }}
                value={salesforceAssetId}
                allowClear
              />

              <Input
                label="Asset name"
                onChange={e => {
                  if (e.length === 0) {
                    setAssetName('');
                    const { assetName, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  setAssetName(e);
                  debounceCallback({ ...filterParams, assetName: e });
                }}
                value={assetName}
                allowClear
              />

              <Select
                label="Asset Status"
                onChange={val => {
                  setAssetStatus(val);
                  if (val === 'all') {
                    const { status, ...rest } = filterParams;
                    debounceCallback(rest);

                    return;
                  }

                  debounceCallback({ ...filterParams, status: val });
                }}
                options={[
                  { id: 'all', label: 'All' },
                  { id: 'active', label: 'Active' },
                  { id: 'In Service', label: 'In Service' },
                  { id: 'Out of Service', label: 'Out of Service' },
                  { id: 'Under Maintenance', label: 'Under Maintenance' }
                ]}
                value={assetStatus}
              />

              <Select
                label="Location"
                showSearch
                onChange={locationSelected => {
                  setLocation(locationSelected);
                  setMarketManager('');

                  const { studentName, instructor, ...restParams } = filterParams;
                  if (locationSelected === 'all') {
                    setFilterParams({ limit: filterParams.limit, skip: filterParams.skip });
                    PersistentRepo.set('allBranches', locationSelected);
                  } else {
                    const [locationType, locationId, branchId] = locationSelected.split('x');
                    setFilterParams(() => {
                      return {
                        ...restParams,
                        location: locationSelected ? branchId : getInitialId('branchId')
                      };
                    });
                  }
                }}
                options={[{ id: `all`, label: `All Branches` }, ...locations]}
                value={location}
              />

              <RangePicker
                label="Date"
                allowClear={true}
                ranges={{
                  Today: [now, now],
                  'Last Week': [moment().subtract(7, 'd'), moment()],
                  'Last Month': [moment().subtract(1, 'months'), moment()]
                }}
                defaultValue={[startDate, endDate]}
                onChange={dates => {
                  const [startDate, endDate] = dates || [];

                  setDateRanges({
                    startDate: startDate || null,
                    endDate: endDate || null
                  });
                  debounceCallback({
                    ...filterParams,
                    dateFrom: startDate?.format('YYYY-MM-DD'),
                    dateTo: endDate?.format('YYYY-MM-DD')
                  });
                }}
              />
            </Search>

            <ButtonContainer>
              <Button
                type="default"
                onClick={() => downloadNonInspectionReport()}
                loading={downloadLoading}
              >
                <Icon type="download" /> Download report
              </Button>
            </ButtonContainer>

            <div style={{ overflowX: 'auto' }}>
              <AsyncTable
                resource={resource}
                pagination
                config={{
                  ...config,
                  get: config.getNonInspection,
                  table: [...config.nonInspectionTable]
                }}
                onChange={handleTableSort}
                params={filterParams}
                fileName={resource}
                onChangePage={setSkip}
              />
            </div>
          </>
        )}

        {/* NOT_CLOSED */}
        {reportType === REPORT_TYPES.NOT_CLOSED && (
          <>
            <Search>
              <Input
                label="Search by Asset Barcode #"
                onChange={e => {
                  if (e.length === 0) {
                    setAssetBarcode('');
                    const { assetBarcode, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  setAssetBarcode(e);
                  debounceCallback({ ...filterParams, assetBarcode: e });
                }}
                value={assetBarcode}
                allowClear
              />
              <Input
                label="Search by Asset Identification #"
                onChange={e => {
                  if (e.length === 0) {
                    setAssetIdentificationNumber('');
                    const { salesforceAssetId, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  setAssetIdentificationNumber(e);
                  debounceCallback({ ...filterParams, salesforceAssetId: e });
                }}
                value={salesforceAssetId}
                allowClear
              />

              <Input
                label="Asset name"
                onChange={e => {
                  if (e.length === 0) {
                    setAssetName('');
                    const { assetName, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  setAssetName(e);
                  debounceCallback({ ...filterParams, assetName: e });
                }}
                value={assetName}
                allowClear
              />

              <Select
                label="Location"
                showSearch
                onChange={locationSelected => {
                  setLocation(locationSelected);
                  setMarketManager('');

                  const { studentName, instructor, ...restParams } = filterParams;
                  if (locationSelected === 'all') {
                    setFilterParams({ limit: filterParams.limit, skip: filterParams.skip });
                    PersistentRepo.set('allBranches', locationSelected);
                  } else {
                    const [locationType, locationId, branchId] = locationSelected.split('x');
                    setFilterParams(() => {
                      return {
                        ...restParams,
                        location: locationSelected ? branchId : getInitialId('branchId')
                      };
                    });
                  }
                }}
                options={[{ id: `all`, label: `All Branches` }, ...locations]}
                value={location}
              />

              <Select
                label="Asset Condition"
                onChange={val => {
                  setAssetCondition(val);
                  if (val === 'all') {
                    const { assetCondition, ...rest } = filterParams;
                    debounceCallback(rest);

                    return;
                  }

                  debounceCallback({ ...filterParams, assetCondition: val });
                }}
                options={[
                  { id: 'all', label: 'All' },
                  { id: 'satisfactory', label: 'Satisfactory' },
                  { id: 'not_satisfactory', label: 'Not Satisfactory' }
                ]}
                value={assetCondition}
              />

              <Input
                label="Search by Driver"
                onChange={e => {
                  if (e.length === 0) {
                    setDriverName('');
                    const { driverName, ...restParams } = filterParams;
                    debounceCallback(restParams);
                    return;
                  }

                  const [first, last = ''] = e.split(' ');
                  setDriverName(e);
                  debounceCallback({ ...filterParams, driverName: `${first} ${last}`.trim() });
                }}
                value={driverName}
                allowClear
              />

              <RangePicker
                label="Date"
                allowClear={true}
                ranges={{
                  Today: [now, now],
                  'Last Week': [moment().subtract(7, 'd'), moment()],
                  'Last Month': [moment().subtract(1, 'months'), moment()]
                }}
                defaultValue={[startDate, endDate]}
                onChange={dates => {
                  const [startDate, endDate] = dates || [];

                  setDateRanges({
                    startDate: startDate || null,
                    endDate: endDate || null
                  });

                  debounceCallback({
                    ...filterParams,
                    dateFrom: startDate?.format('YYYY-MM-DD'),
                    dateTo: endDate?.format('YYYY-MM-DD')
                  });
                }}
              />
            </Search>

            <div style={{ overflowX: 'auto' }}>
              <AsyncTable
                resource={resource}
                pagination
                config={{
                  ...config,
                  get: config.getNotClosedDvirs,
                  table: [...config.notClosedTable]
                }}
                onChange={handleTableSort}
                params={filterParams}
                fileName={resource}
                onChangePage={setSkip}
              />
            </div>
          </>
        )}
      </Card>
    </PageContainer>
  );
};
